export default `
	videoSource
	caption
	date @date(format: rfc822)
	primaryImage {
		url(transform:videoBannerPoster)
		filename
		id
		width
		height
		kind
	}
	links {
		... on LinksItem {
			itemTitle
			itemUrl
		}
	}
`;
